import { NgModule } from '@angular/core';
import { SelectSearchInputComponent } from './components/select-search-input/select-search-input.component';
import { IonicModule } from '@ionic/angular';
import { DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { DatePickerInputComponent } from './components/date-picker-input/date-picker-input.component';
import { StatusFilterComponent } from './components/status-filter/status-filter.component';
import { AppliedFiltersRowComponent } from './components/applied-filters-row/applied-filters-row.component';
import { BubblePaginationDirective } from './directives/bubble-pagination.directive';
import { SelectSearchInputVehiclesComponent } from './components/select-search-input-vehicles/select-search-input-vehicles.component';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { MaskitoDirective } from '@maskito/angular';
import { CpfCnpjPipe } from './pipes/cpf-cnpj.pipe';
import { MobilePhonePipe } from './pipes/mobile-phone.pipe';
import { CepPipe } from './pipes/cep.pipe';
import { DatetimeFormatPipe } from './pipes/datetime-format.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { DataValidadeFormatPipe } from './pipes/data-validade-format.pipe';
import { DateDashTimePipe } from './pipes/date-dash-time.pipe';
import { DateMaskDirective } from './directives/date-mask.directive';
import { CpfMaskDirective } from './directives/cpf-mask.directive';
import { CepMaskDirective } from './directives/cep-mask.directive';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { MobilePhoneMaskDirective } from './directives/mobile-phone-mask.directive';
import { CnpjMaskDirective } from './directives/cnpj-mask.directive';
import { LicensePlateDirective } from './directives/license-plate.directive';
import { UppercaseDirective } from './directives/uppercase.directive';
import { FileMultipleUploadComponent } from './components/file-multiple-upload/file-multiple-upload.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { HourPickerInputComponent } from './components/hour-picker-input/hour-picker-input.component';
import { CalendarModule } from 'angular-calendar';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { EmitirDocumentoComponent } from './components/emitir-documento/emitir-documento.component';
import { YearPickerInputComponent } from './components/year-picker-input/year-picker-input.component';
import { ModalFiltersComponent } from './components/modals/modal-filters/modal-filters.component';
import { ModalHistoricComponent } from './components/modals/modal-historic/modal-historic.component';
import { ModalMotivoRecusaComponent } from './components/modals/modal-motivo-recusa/modal-motivo-recusa.component';
import { ModalMotivoBloqueioComponent } from './components/modals/modal-motivo-bloqueio/modal-motivo-bloqueio.component';
import { ModalNotificacaoBloqueioComponent } from './components/modals/modal-notificacao-bloqueio/modal-notificacao-bloqueio.component';
import { CreateRoleModalComponent } from './components/create-role-modal/create-role-modal.component';
import { GenericHistoricComponent } from './components/modals/generic-historic/generic-historic.component';
import { TableDynamicComponent } from './components/table-dynamic/table-dynamic.component';
import { SelectSearchInputEntitiesComponent } from './components/select-search-input-entities/select-search-input-entities.component';
import { SelectSearchInputComponentFilter } from './components/select-search-input-filter/select-search-input-filter.component';
import { SelectSearchMultipleComponent } from './components/select-search-multiple/select-search-multiple.component';
import { WorkflowStatusPopoverComponent } from './components/workflow-status-popover/workflow-status-popover.component';
import { ModalShowFilesComponent } from './components/modals/modal-show-files/modal-show-files.component';
import { ImportModalComponent } from './components/modals/import-modal/import-modal.component';
import { ImportValidationComponent } from './components/modals/import-validation/import-validation.component';
import { TableDefaultComponent } from './components/table-default/table-default.component';
import { NotificationsComponent } from './components/navbar/notifications/notifications.component';
import { ModalComponent } from './components/modal/modal.component';
import { AlertComponent } from './components/alert/alert.component';
import { MaterialModule } from './material.module';
import { DynamicPipe } from './pipes/dynamic.pipe';
import { DatetimePickerInputComponent } from './components/datetime-picker-input/datetime-picker-input.component';
import { IntegerRangeSelectorComponent } from './components/integer-range-selector/integer-range-selector.component';
import { DynamicFormatPipe } from './pipes/dynamic-format.pipe';
import { NumericLimitDirective } from './directives/numeric-limit.directive';
import { FotoCropModalComponent } from './components/modals/foto-crop-modal/foto-crop-modal.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './paginator/custom-paginator-intl';

@NgModule({
  declarations: [
    // Components
    SelectSearchInputComponent,
    SelectSearchMultipleComponent,
    DatePickerInputComponent,
    StatusFilterComponent,
    AppliedFiltersRowComponent,
    SelectSearchInputVehiclesComponent,
    FileMultipleUploadComponent,
    CalendarComponent,
    HourPickerInputComponent,
    FileUploadComponent,
    EmitirDocumentoComponent,
    YearPickerInputComponent,
    ModalFiltersComponent,
    ModalHistoricComponent,
    ModalMotivoRecusaComponent,
    ModalMotivoBloqueioComponent,
    ModalNotificacaoBloqueioComponent,
    CreateRoleModalComponent,
    GenericHistoricComponent,
    TableDynamicComponent,
    SelectSearchInputEntitiesComponent,
    SelectSearchInputComponentFilter,
    WorkflowStatusPopoverComponent,
    ModalShowFilesComponent,
    ImportModalComponent,
    ImportValidationComponent,
    TableDefaultComponent,
    NotificationsComponent,
    ModalComponent,
    AlertComponent,
    DatetimePickerInputComponent,
    IntegerRangeSelectorComponent,
    FotoCropModalComponent,

    // Pipes
    DateFormatPipe,
    CpfCnpjPipe,
    MobilePhonePipe,
    CepPipe,
    DatetimeFormatPipe,
    PhonePipe,
    FileSizePipe,
    DataValidadeFormatPipe,
    DateDashTimePipe,
    DynamicPipe,
    DynamicFormatPipe,

    // Directives
    BubblePaginationDirective,
    DateMaskDirective,
    CpfMaskDirective,
    CepMaskDirective,
    PhoneMaskDirective,
    MobilePhoneMaskDirective,
    CnpjMaskDirective,
    LicensePlateDirective,
    UppercaseDirective,
    NumericLimitDirective,
  ],
  imports: [MaterialModule, IonicModule, MaskitoDirective, CalendarModule],
  exports: [
    // Modules
    IonicModule,
    MaterialModule,

    // Components
    SelectSearchInputComponent,
    SelectSearchMultipleComponent,
    DatePickerInputComponent,
    StatusFilterComponent,
    AppliedFiltersRowComponent,
    BubblePaginationDirective,
    SelectSearchInputVehiclesComponent,
    FileMultipleUploadComponent,
    CalendarComponent,
    HourPickerInputComponent,
    FileUploadComponent,
    EmitirDocumentoComponent,
    YearPickerInputComponent,
    AlertComponent,
    DatetimePickerInputComponent,
    IntegerRangeSelectorComponent,
    FotoCropModalComponent,

    // Pipes
    DateFormatPipe,
    CpfCnpjPipe,
    MobilePhonePipe,
    CepPipe,
    DatetimeFormatPipe,
    PhonePipe,
    FileSizePipe,
    DataValidadeFormatPipe,
    DateDashTimePipe,
    DynamicPipe,
    DynamicFormatPipe,

    // Directives
    MaskitoDirective,
    BubblePaginationDirective,
    DateMaskDirective,
    CpfMaskDirective,
    CepMaskDirective,
    PhoneMaskDirective,
    MobilePhoneMaskDirective,
    CnpjMaskDirective,
    LicensePlateDirective,
    UppercaseDirective,
    NumericLimitDirective,
  ],
  providers: [
    DatePipe,
    CurrencyPipe,
    DecimalPipe,
    // Garante o intl PT-BR ("Itens por página", "X–Y de Z itens") também nos
    // módulos lazy: o MatPaginatorModule (via MaterialModule) registra o
    // MAT_PAGINATOR_INTL_PROVIDER no injector do módulo lazy, que sem isto
    // resolveria o MatPaginatorIntl padrão (inglês). Ver CoreModule (raiz).
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class SharedModule {}
